import React from 'react';
import cx from 'classnames';
import { compose, setDisplayName, defaultProps } from 'recompose';

import styles from './styles.css';

export type Props = {
  children: any;
  className?: string;
  baseClassName?: string;
};

export const Body = compose<Props, Props>(
  setDisplayName('Body'),
  defaultProps({
    baseClassName: styles.root,
  })
)(({ children, className, baseClassName }) => (
  <div className={cx(baseClassName, className)}>{children}</div>
));
